<template>
    <article>
        <v-input-field
            label="Title"
            description="The title for the note."
            v-model="note.title"
            placeholder="Enter Title"
            :readonly="readonly"
            :state="errorState('title')"
            :error="error('title')"
        />

        <v-input-field
            label="Reference"
            description="The scripture reference."
            v-model="note.reference"
            :readonly="readonly"
            placeholder="Enter Scripture Reference"
            :state="errorState('reference')"
            :error="error('reference')"
        />

        <v-rich-text-field
            label="Scripture"
            description="The scripture content."
            v-model="note.content"
            :readonly="readonly"
            placeholder="Enter Scripture Content"
            :state="errorState('content')"
            :error="error('content')"
        />

        <v-input-field
            label="Link"
            description="Bible.com link."
            v-model="note.url"
            :readonly="readonly"
            placeholder="Enter URL"
            :state="errorState('url')"
            :error="error('url')"
        />
    </article>
</template>

<script>
    import BaseType from './Base'

    export default {
        extends: BaseType,
        data()
        {
            return {
                defaults: {
                    title: '',
                    reference: '',
                    content: '',
                    url: ''
                },
                rules: {
                    reference: "required",
                    content: "required"
                }

            }
        }
    }
</script>